import { useIsAuthenticated } from '@azure/msal-react';
import React, { useContext, useEffect, useState } from 'react';
import { createContext } from 'react';
import { EMPTY_IMAGE, toast } from '../../components/common';
import { GetUser, /*GetUserPhoto, GetUserToken, */ Login } from '../../services/Api/users/useApiUser';

const UserContext = createContext();

export const getUserInformationFromLocalStorage = () => {
    for (var i = 0; i < localStorage.length; i++) {
        try {
            var li = JSON.parse(localStorage.getItem(localStorage.key(i)));
            if (li.authorityType && li.authorityType === 'MSSTS') {
                return li;
            }
        } catch {}
    }
    return { username: '', name: '' };
};

const UserProvider = ({ children }) => {
    const isAuthenticated = useIsAuthenticated();
    const [userImage/*, setUserImage*/] = useState(EMPTY_IMAGE.src);
    const userDetails = getUserInformationFromLocalStorage();
    const [isLoading, setIsLoading] = useState(true);
    const [appUserDetails, setAppUserDetails] = useState(null);
    const [rolePermissions, setRolePermissions] = useState(null);
    const [permissions, setPermissions] = useState(null);
    const [userNavItems, setUserNavItems] = useState([]);
    const [token/*, setToken*/] = useState('');

    const hasRolePermission = (id) => {
        if (!rolePermissions) return undefined;
        if (!rolePermissions.length) return false;
        return rolePermissions.some((r) => r.id === id);
    };

    const hasPermission = (id) => {
        if (!permissions) return undefined;
        if (!permissions.length) return false;
        return permissions.some((p) => p.id === id);
    };

    useEffect(() => {
        setIsLoading(true);
        if (userDetails.username) {
            try {
                Login({ email: userDetails.username }).then((response) => {
                    if (response && response.data) {
                        if (response.data.rolePermissions) {
                            setRolePermissions(response.data.rolePermissions);
                        }
                        if (response.data.permissions) {
                            setPermissions(response.data.permissions);
                        }
                    }
                });

                GetUser({ email: userDetails.username, basic: "true" }).then((response) => {
                    if (response && response.data) {
                        setAppUserDetails(response.data);
                    }
                    setIsLoading(false);
                });
            } catch (e) {
                setIsLoading(false);
                toast.error();
                console.error(e);
            }
        } else {
            setIsLoading(false);
        }
    }, [userDetails.username]);

    useEffect(() => {
        const newNavItems = [
            {
                id: 0,
                name: 'Dashboard',
                //icon: 'building',
                route: '/',
                visible: true,
            },
            {
                id: 1,
                name: 'Schedules',
                //icon: 'list',
                route: '/schedules',
                visible: hasRolePermission('ns'),
            },
            {
                id: 2,
                name: 'Users',
                //icon: 'users',
                route: '/users',
                visible: hasRolePermission('nu'),
            },
        ];
        setUserNavItems(newNavItems.filter((i) => i.visible));
        //eslint-disable-next-line
    }, [rolePermissions]);

    return (
        <UserContext.Provider
            value={{
                isAuthenticated,
                appUserDetails,
                userDetails,
                name:
                    appUserDetails && appUserDetails.firstname
                        ? `${appUserDetails.firstname} ${appUserDetails.surname}`
                        : userDetails.name || '',
                role: appUserDetails?.rolename || '',
                rolePermissions,
                hasRolePermission,
                hasPermission,
                instances: () => (appUserDetails?.instances || []).filter((i) => i.user),
                userNavItems,
                isLoading,
                userImage,
                token,
            }}
        >
            {children}
        </UserContext.Provider>
    );
};

const useGetUser = () => {
    const useUserContext = useContext(UserContext);
    return useUserContext;
};

export { UserContext, UserProvider, useGetUser };
